import { render, staticRenderFns } from "./InvoiceButton.vue?vue&type=template&id=0661ef86&"
import script from "./InvoiceButton.vue?vue&type=script&lang=js&"
export * from "./InvoiceButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports